var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 36,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 18,
  r: 17.5,
  fill: "#FEFEFE",
  opacity: 0.7
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M22.333 22.223c-.675 0-1.28.271-1.742.696l-6.338-3.75c.045-.208.08-.416.08-.633a3 3 0 0 0-.08-.632l6.267-3.714c.48.452 1.111.732 1.813.732C23.81 14.922 25 13.71 25 12.21S23.809 9.5 22.333 9.5s-2.666 1.21-2.666 2.71c0 .218.035.425.08.633l-6.267 3.714a2.63 2.63 0 0 0-1.813-.732C10.19 15.825 9 17.036 9 18.536s1.191 2.711 2.667 2.711c.702 0 1.333-.28 1.813-.732l6.329 3.76c-.045.189-.071.388-.071.586 0 1.455 1.164 2.639 2.595 2.639s2.596-1.184 2.596-2.639-1.165-2.638-2.596-2.638"
})));
export default SvgShare;